import { Box, Flex, Text } from '@mantine/core';
import {
  CELL_PADDING,
  FONT_SIZE,
  HEADER_BG,
  INDENT_SIZE,
  LINE_HEIGHT,
  TEXT_COLOR
} from '../tableConstants';
import { SeeMoreText } from './SeeMoreText';
import { useTableStyles } from '../tableConstants';
import { idCreator } from '../../../../../Project/utils/idCreator';

export const SingleFundHeaderRow = ({ levelIndex = 0, level, name, nameContent, id }) => {
  const { classes } = useTableStyles();
  const hasContent = Boolean(level || name || nameContent);
  const rowId =
    id || `formpf-single-fund-header-${idCreator(`${levelIndex}-${level || name || 'empty'}`)}`;

  if (!hasContent) return null;

  return (
    <Flex id={rowId} className={classes.borderBottom}>
      <Flex id={`${rowId}-left`} maw="50%" miw="50%">
        {Array.from({ length: levelIndex }).map((_, index) => (
          <Box
            id={`${rowId}-indent-${index}`}
            key={index}
            maw={INDENT_SIZE}
            miw={INDENT_SIZE}
            className={classes.borderRight}
            bg={HEADER_BG}
          ></Box>
        ))}
        {level && (
          <Text
            id={`${rowId}-level`}
            p={CELL_PADDING}
            className={classes.borderRight}
            bg={HEADER_BG}
            maw={INDENT_SIZE}
            miw={INDENT_SIZE}
            ta="center"
            c={TEXT_COLOR}
            fz={FONT_SIZE}
            lh={LINE_HEIGHT}
          >
            {level}
          </Text>
        )}

        {name && (
          <Text
            id={`${rowId}-name`}
            p={CELL_PADDING}
            bg={HEADER_BG}
            flex="auto"
            c={TEXT_COLOR}
            fz={FONT_SIZE}
            lh={LINE_HEIGHT}
            className={classes.borderRight}
          >
            <SeeMoreText text={name} />
          </Text>
        )}

        {nameContent}
      </Flex>

      <Text id={`${rowId}-right`} p={CELL_PADDING} bg={HEADER_BG} miw="50%" maw="50%"></Text>
    </Flex>
  );
};
